import React from 'react';
import Slider from './Slider.jsx';

const splashDB = {
	img: ['db/101/101-1.jpg','db/101/101-2.jpg','db/101/101-3.jpg','db/101/101-4.jpg'],
	product:{
		name: 'Black Vigwam',
		material: 'порцелян',
		amount: 10,
		diametr: 0,
		height: 9,
		price: 5
	}
}

export default class Splash extends React.Component{
	constructor(props){
		super(props);
		this.state={unmount: false};
	}
	componentDidMount(){
		setTimeout(() =>document.querySelector('.cube').style.animation='none',6000);
	}
	render(){
		if(this.state.unmount)return null;
		return(
			<div id='splash'>
				<div className='splash__animation'>
					<Slider arrow={false} img={splashDB.img} showAnime={true} product={splashDB.product}/>
					<div className='splash__aimation__cursor'></div>
				</div>
				<div className='splash__title'>
					<div className='splash__title__hint'>try to clamp and rotate cubes for Your comfort</div>
					<div onClick={() =>this.setState({unmount: true})} className='splash__title__go'>visit website</div>
				</div>
			</div>
		)
	}
}